import { render, staticRenderFns } from "./NoLayout.vue?vue&type=template&id=13e6bf32"
import script from "./NoLayout.vue?vue&type=script&lang=js"
export * from "./NoLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports